import React from 'react';

const ArrowBack = ({ ...props }) => {
  return (
    <svg
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='icon-back'
      {...props}
    >
      <g>
        <circle cx='24' cy='22' r='16' fill='#171B27'></circle>
      </g>
      <path
        d='M27 15L20 22L27 29'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      ></path>
      <defs>
        <filter
          id='filter0_dd_1708_129321'
          x='0'
          y='0'
          width='48'
          height='48'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix'></feFlood>
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          ></feColorMatrix>
          <feOffset dy='4'></feOffset>
          <feGaussianBlur stdDeviation='2'></feGaussianBlur>
          <feComposite in2='hardAlpha' operator='out'></feComposite>
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          ></feColorMatrix>
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_1708_129321'
          ></feBlend>
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          ></feColorMatrix>
          <feOffset dy='2'></feOffset>
          <feGaussianBlur stdDeviation='4'></feGaussianBlur>
          <feComposite in2='hardAlpha' operator='out'></feComposite>
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          ></feColorMatrix>
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_1708_129321'
            result='effect2_dropShadow_1708_129321'
          ></feBlend>
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect2_dropShadow_1708_129321'
            result='shape'
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
};

export default ArrowBack;
